import React, {useState} from "react";

export const WizardContext = React.createContext();

export const WizardProvider = ({ children }) => {
  const [formValues, setFormValues] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [showWizard, setShowWizard] = useState(true);
  const [error, setError] = useState(false);

  return (
    <WizardContext.Provider
      value={{
        error,
        next: () => setCurrentStep(currentStep + 1),
        previous: () => setCurrentStep(currentStep - 1),
        setError,
        skip: () => setShowWizard(false),
        step: currentStep,
        formValues,
        setFormValues,
        showWizard,
        setShowWizard
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};